// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Z0bk","inputWrap":"CustomTip_inputWrap__1bsOK"};